var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1443 14.52C20.7843 14.52 22.9203 12.36 22.9203 9.71998C22.9203 7.07998 20.7603 4.91998 18.1203 4.91998C15.4803 4.91998 13.3203 7.07998 13.3203 9.71998C13.3203 15.024 17.6163 19.32 22.9203 19.32C22.9203 19.32 19.7763 18.144 18.1443 14.52ZM10.9203 9.71998C10.9203 7.07998 8.76031 4.91998 6.12031 4.91998C3.48031 4.91998 1.32031 7.07998 1.32031 9.71998C1.32031 15.024 5.61631 19.32 10.9203 19.32C10.9203 19.32 7.77631 18.144 6.14431 14.52C8.78431 14.52 10.9203 12.36 10.9203 9.71998Z",
    fill: "url(#paint0_linear_7243_37038)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7243_37038",
    x1: -0.0836868,
    y1: 23.64,
    x2: 26.2808,
    y2: 9.88509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.603e6e02d62a763fa4f3fa1ee8a7f2a6.svg";
export { ForwardRef as ReactComponent };